<template>
  <div>
    <b-container fluid>
      <b-row align-h="center" class="noselect">
        <b-col cols="11" md="6" lg="4" xl="3" class="login mt-5 rounded">
          <b-img center :src="require('../assets/img/easytick.png')" width="170"></b-img>

          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="danger"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p>{{ feedback }}</p>
            <b-progress
              variant="danger"
              :max="dismissSecs"
              :value="dismissCountDown"
              height="4px"
            ></b-progress>
          </b-alert>

          <b-form @submit="onSubmit">
            <b-form-group
              label="Login:"
              label-for="input-login"
              description="Informe seu login Easytick"
            >
              <masked-input
                id="input-login"
                ref="login"
                v-model="form.login"
                type="text"
                class="form-control"
                inputmode="numeric"
                :mask="cpfMask"
                :guide="false"
                required
              ></masked-input>
            </b-form-group>

            <b-form-group
              label="Senha:"
              label-for="input-pass"
              description="Informe sua senha Easytick"
            >
              <b-form-input
                id="input-pass"
                v-model="form.pass"
                type="password"
                required
              ></b-form-input>
            </b-form-group>

            <!-- reCAPTCHA v2 Widget -->
            <div class="d-flex justify-content-center my-3">
              <vue-recaptcha
                :sitekey="recaptchaSiteKey"
                @verify="onCaptchaVerify"
                @expired="onCaptchaExpired"
                hl="pt-BR"
              ></vue-recaptcha>
            </div>

            <!-- Error message for missing CAPTCHA verification -->
            <b-alert
              v-if="showCaptchaError"
              variant="warning"
              show
              class="text-center"
            >
              Por favor, confirme que você não é um robô
            </b-alert>

            <b-button class="d-block" type="submit" variant="primary"
              :disabled="!isFormValid"
            >
              Entrar
            </b-button>

            <span class="d-block my-3 captcha font-weight-lighter text-muted">Esta página é protegida pelo reCAPTCHA e está sujeita à <a href="https://www.google.com/policies/privacy/" target="_blank">Política de privacidade</a> e aos <a href="https://www.google.com/policies/terms/" target="_blank">Termos de serviço</a> do Google.</span>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <div class="bk"></div>
  </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import MaskedInput from 'vue-text-mask'

export default {
  name: 'Login',
  components: {
    VueRecaptcha,
    MaskedInput
  },
  data () {
    return {
      cpfMask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
      form: {
        login: '',
        pass: '',
        recaptcha: '',
        user_agent: ''
      },
      captchaVerified: false,
      feedback: '',
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted () {
    this.$refs.login.$el.focus()
  },
  computed: {
    recaptchaSiteKey () {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY || '6LeuKN4pAAAAADyyMtbHPPzOvy1KfKVghTjLdFbU'
    },
    isFormValid () {
      return this.form.login !== '' && this.form.pass !== '' && this.captchaVerified
    },
    showCaptchaError () {
      return (this.form.login !== '' && this.form.pass !== '') && !this.captchaVerified
    }
  },
  methods: {
    onCaptchaVerify (response) {
      this.captchaVerified = true
      this.form.recaptcha = response
    },
    onCaptchaExpired () {
      this.captchaVerified = false
      this.form.recaptcha = ''
    },
    async onSubmit (evt) {
      evt.preventDefault()
      this.form.user_agent = navigator.userAgent

      try {
        let loginResp = await this.$http.post(process.env.VUE_APP_URL_APP + '/b/login', this.form)

        this.$timetrack.init('easytick', 60)

        const role = loginResp.body.role

        this.$session.set('login', this.form.login)

        if (role === 'organizer') {
          this.$session.set('logged', true)
          this.$session.set('role', 'organizer')
          return this.$router.push({name: 'OrganizerEvents'})
        }

        this.$session.set('role', 'admin')
        this.$session.set('logged', true)
        return this.$router.push({name: 'Events'})
      } catch (err) {
        this.$session.set('logged', false)
        this.feedback = err.body.message
        this.dismissCountDown = this.dismissSecs

        // Reset CAPTCHA on error
        this.captchaVerified = false
        this.form.recaptcha = ''
      }
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    }
  }
}
</script>
